<!-- A metal's square artwork with its "important" bell badge in the top-right
corner. Art lives at /public/mine-my-phone/images/metals/<slug>/icon.png. -->
<template>
  <div class="relative">
    <RevIllustration
      :src="`/mine-my-phone/images/metals/${metal.slug}/icon.png`"
      alt=""
      aria-hidden="true"
      :width="size"
      :height="size"
    />
    <ImportantBadge v-if="metal.important" class="absolute end-6 top-6" />
  </div>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'

import ImportantBadge from '~/scopes/campaign/components/UI/ImportantBadge.vue'
import type { Metal } from '~/scopes/campaign/data/metals/types'

defineProps<{ metal: Metal; size: number }>()
</script>
